import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Cookies from "js-cookie";


const PremiumView = Backbone.View.extend({

    el: $('body')[0],
    
    initialize: function () {

        var _this = this;

        this.observer = new MutationObserver(this.observer_callback)

        this.observer.observe(this.el, { attributes: true, characterData: true, childList: true, subtree: true })

        window.addEventListener('message', this.receiveMessage, false)

        // this.render();
    },

    receiveMessage: function(e){
      console.log('Hi there!', e.data)

      if (e.data.confirmation_screen) {
        $('body').addClass('no-scroll')
        $('#loading-splash').addClass('active')
        
        setTimeout(function(){
            location.href = '/account'
        }, 2000)
      }

      if (e.data.logged_in) {
        var url = new URL(location.href)
        
        // var logged_out = $('#account-out').length
        
        if (url.searchParams.get('r')) {
            location.href = url.searchParams.get('r')
        } else {
            // if (e.data.refresh && logged_out) {

            //     location.href = location.href
            // }
            // location.href = location.href
        }
      }
    },

    session: function() {

      setTimeout(function(){

        var spektrix_customer = localStorage.getItem('spektrixCustomer')

        console.log(spektrix_customer)
        if (spektrix_customer) {

          var spektrix_data = JSON.parse(spektrix_customer)

          var email = spektrix_data.data.email || null

            $.get(window.ajax_client.ajax_url, {
                'action': 'spektrix_session',
                'spektrix_customer': email
            }, function(response){
                response.hasSession || Cookies.remove('spektrix_customer')
            })
          
        }

      }, 1000)
      
    },

    observer_callback: function(mutationsList, observer) {

        // Use traditional 'for loops' for IE 11
        for(var mutation of mutationsList) {

            if($(mutation.target).is('[data-logged-in-status-customer-email-address]')){
                console.log($(mutation.target).text())

                var data = $(mutation.target).text()
                Cookies.set('spektrix_customer', data, { expires: 180 })

                $.get(window.ajax_client.ajax_url, {
                    'action': 'spektrix_session',
                    'spektrix_customer': data
                }, function(response){
                    console.log(response)
                })
            }
        }
    },

    keep_alive: function(){

        setInterval(function(){

            var payload = {
                credentials: "include",
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                },
                method: "GET"
            }

            fetch('https://system.spektrix.com/shermantheatre/api/v3/customer', payload).then(function (response) {
              return response.json()
            }).then(function (data) {
              console.log(data);
            })

        }, 60000)


        // setTimeout(function(){

        //   var spektrix_customer = localStorage.getItem('spektrixCustomer')

        //   if (spektrix_customer) {

        //     var spektrix_data = JSON.parse(spektrix_customer)

        //     if (!spektrix_data.data.email) {

        //         Cookies.remove('spektrix_customer')
            
        //     } else {

        //         Cookies.set('spektrix_customer', spektrix_data.data.email, { expires: 180 })
        //     }
        //   }

        // }, 5000)

    },

    render: function(){

        this.session()
        this.keep_alive()
    }

})

export default PremiumView